"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNameComputationDetails = exports.getAccessibleName = void 0;
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
const compute_text_alternative_1 = require("./lib/compute_text_alternative");
/**
 * Compute the accessible name for a given `Element`.
 * @param elem - The `Element` whose accessible name will be calculated.
 */
function getAccessibleName(elem, options = {}) {
    return compute_text_alternative_1.computeTextAlternative(elem, options).name;
}
exports.getAccessibleName = getAccessibleName;
/**
 * Get details surrounding the computation of the accessible name for a given
 * `Element`
 * @param elem - The `Element` whose accessible name will be calculated.
 */
function getNameComputationDetails(elem, options = {}) {
    return compute_text_alternative_1.computeTextAlternative(elem, options);
}
exports.getNameComputationDetails = getNameComputationDetails;
//# sourceMappingURL=accessible_name.js.map